import { authenticatedFetch } from "@/libs/api";

// What a successful approval sets off outside the platform (backend services/downstreamSync).
// Shared by the System Detail card and the admin list.

export const STATUS_META = {
  SHADOW:      { label: "Recorded only",  color: "default",    help: "Sync is in SHADOW mode: this records what would have been sent. Nothing was sent." },
  PENDING:     { label: "Queued",         color: "processing", help: "Waiting for the background worker to send it." },
  SENDING:     { label: "Sending",        color: "processing", help: "Being sent right now." },
  DONE:        { label: "Done",           color: "success",    help: "Sent and accepted." },
  FAILED:      { label: "Failed",         color: "error",      help: "Refused or could not be sent. Fix the cause, then retry." },
  BLOCKED:     { label: "Missing data",   color: "warning",    help: "Not sent: something it needs is missing or not open yet. Fix it, then retry." },
  SKIPPED:     { label: "Not needed",     color: "default",    help: "Nothing to do for this system (see the reason)." },
  NEEDS_CHECK: { label: "Check manually", color: "magenta",    help: "The outcome is unknown — the account may exist. Check the APP admin before retrying." },
};

export const TARGET_LABELS = {
  APP: "Powow APP account",
  CRM: "Partner CRM",
};

export const MODE_META = {
  OFF:    { label: "Off",                       color: "default" },
  SHADOW: { label: "Shadow — records only",     color: "gold" },
  ON:     { label: "On — sends",                color: "green" },
};

export const RETRYABLE = ["FAILED", "BLOCKED", "NEEDS_CHECK", "SHADOW", "SKIPPED"];

export async function retrySyncTask(taskId) {
  const res = await authenticatedFetch(`/api/downstream-sync/tasks/${taskId}/retry`, { method: "POST" });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || "Retry failed");
  return json.data;
}

/** Confirm text for a retry: NEEDS_CHECK means an account may already exist. */
export function retryConfirmText(task) {
  if (task.status === "NEEDS_CHECK") {
    return "Only retry after checking in the APP admin that this customer has no account — retrying creates one.";
  }
  if (task.status === "SHADOW") return "Decide this row again with the current settings and data.";
  return "Check it again with the current data and send it if nothing is missing.";
}

export function formatTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString("en-AU", { hour12: false });
}
